import * as React from 'react';
import type { SVGProps } from 'react';
const SvgActivity = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 11.75h3.5l2-7 3.5 14.5 2-7.5h3.5"
    />
  </svg>
);
export default SvgActivity;
